export default "__VITE_ASSET__D$7mvLNU__"